/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assistantsList } from "../funcs/assistantsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAssistantsResult } from "../models/components/listassistantsresult.js";
import {
  ListAssistantsRequest,
  ListAssistantsSecurity,
} from "../models/operations/listassistants.js";
import { unwrapAsync } from "../types/fp.js";
export type AssistantsListQueryData = ListAssistantsResult;

export function prefetchAssistantsList(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAssistantsRequest | undefined,
  security?: ListAssistantsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAssistantsListQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAssistantsListQuery(
  client$: GramCore,
  request?: ListAssistantsRequest | undefined,
  security?: ListAssistantsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AssistantsListQueryData>;
} {
  return {
    queryKey: queryKeyAssistantsList({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function assistantsListQueryFn(
      ctx,
    ): Promise<AssistantsListQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(assistantsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAssistantsList(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "assistants", "list", parameters];
}
